module.exports = __webpack_public_path__ + "img/asuka111-koi.27e54ef.jpg";